/**
 * Format Y axis values
 */
export const formatYValue = (value: number, prefix = '', suffix = ''): string => {
  // Format large numbers with k suffix
  let formattedValue = value;
  if (value >= 1000) {
    formattedValue = Math.round((value / 1000) * 10) / 10;
    return `${prefix}${formattedValue}${suffix || 'k'}`;
  }

  return `${prefix}${formattedValue}${suffix}`;
};
